import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import HTMLReactParser from "html-react-parser";
import parse from "html-react-parser"
import "./index.css";

export default function DateTime({webpageData}) {
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";
  const bannerData = webpageData?.banner || {}
  return (
    <Container>
      <Row className="">
        <Col className="">
          <div className="nft-banner-info">
            <div className="nft-info-item">
              <Image src={imgCDNURL + "locationicon.webp"} className="nft-locationicon" />
              {bannerData.eventDetails.eventAddressLink ? (
                                            <a href={parse(bannerData.eventDetails.eventAddressLink)} target="_blank" rel="noopener noreferrer">
                                                <span>
                                                    {parse(bannerData.eventDetails.eventVenue)}<br />
                                                    {parse(bannerData.eventDetails.eventAddress)}
                                                </span>
                                            </a>
                                        ) : (
                                            <span>
                                                {parse(bannerData.eventDetails.eventVenue)}<br />
                                                {parse(bannerData.eventDetails.eventAddress)}
                                            </span>
                                        )}
            </div>
            <div className="nft-info-item">
              <Image src={imgCDNURL + "calendericon.webp"} className="nft-calendericon" />
              <span>
                                                {parse(bannerData.eventDetails.eventDate)}<br />
                                                {parse(bannerData.eventDetails.eventTime)}
                                            </span>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
